import React from 'react';
import {
  Button,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardText,
  CardFooter,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import 'moment-timezone';
import { hasRole } from '../../services/authService';

const TimeCard = ({ card, payWeek, user }) => {
  const submitted =
    card.submitDate !== null ? moment(card.submitDate).format('lll') : 'N/A';
  const approved =
    card.approvalDate !== null
      ? moment(card.approvalDate).format('lll')
      : 'N/A';
  const weekStart = payWeek[0]
    ? moment(payWeek[0].startDate).format('ll')
    : 'N/A';
  const weekEnd = payWeek[0] ? moment(payWeek[0].endDate).format('ll') : 'N/A';
  let headerColor = 'blue-bg';
  if (hasRole('ROLE_MANAGER')) {
    if (card.isSubmitted && card.isApproved) headerColor = 'green-bg';
    else if (!card.isApproved && card.isSubmitted) headerColor = 'yellow-bg';
    else if (!card.isSubmitted && !card.isApproved) headerColor = 'red-bg';
  }
  return (
    <Col md={4}>
      <Card className="mb-4">
        <CardHeader className={`${headerColor}`}>
          {weekStart} - {weekEnd}
        </CardHeader>
        <CardBody>
          <CardText>User ID: {user ? user.initials : 'N/A'}</CardText>
          <CardText>Submitted: {card.isSubmitted ? 'Yes' : 'No'}</CardText>
          <CardText>Submitted @ {submitted}</CardText>
          <CardText>Approved: {card.isApproved ? 'Yes' : 'No'}</CardText>
          <CardText>Approved @ {approved}</CardText>
        </CardBody>
        <CardFooter className="text-center">
          <Button tag={Link} to={'/time-cards/' + card.id}>
            View
          </Button>
        </CardFooter>
      </Card>
    </Col>
  );
};

export default TimeCard;



// WEBPACK FOOTER //
// ./src/components/timecard/TimeCard.js